import React from "react";
import {
  Text,
  Avatar,
  Stack,
  HStack,
  Image,
  Flex,
  Box,
  Circle,
} from "@chakra-ui/react";
import { color3, textSecondary } from "../../../../../utils/colors";
import StatusBadge from "../../../../../components/badges/StatusBadge";
import MoreButtonLite from "../../../../../components/buttons/MoreButtonLite";
import StatusButtonNewLite from "../../../../../components/buttons/StatusButtonNewLite";

export const columns = (
  t,
  isMobile,
  textPrimaryMode,
  whiteMode,
  setUserId,
  setShowDeleteConfirmation,
  openEditSidePanelModal,
  tenantRegistrationEmail,
  loggedInUserEmail
) => {
  return [
    {
      Header: () => (
        <Flex h="100%" w="100%">
          <Flex align="center" cursor="pointer">
            <Text>{t("user.columnUser")}</Text>
          </Flex>
        </Flex>
      ),
      disableSortBy: true,
      width: 300,
      accessor: "lastName",
      Cell: ({ row }) => {
        const { name, image, patientID, status, email } = row.original;

        const isOwner = tenantRegistrationEmail === email;
        const isLoggedInUser = loggedInUserEmail === email;

        return (
          <HStack gap={2} position="relative">
            {image ? (
              <Image
                size="sm"
                src={image}
                alt={name}
                borderRadius="10rem"
                objectFit="cover"
              />
            ) : (
              <>
                {!isMobile && (
                  <Avatar
                    h={["2.5rem", "2rem", "2rem"]}
                    w={["2.5rem", "2rem", "2rem"]}
                    name={name}
                    // bg="#dceeff"
                    // color="#3a74a9"
                    bg={textPrimaryMode}
                    color={whiteMode}
                  />
                )}
              </>
            )}

            {isLoggedInUser && (
              <Circle
                w="0.75rem"
                h="0.75rem"
                bg={color3}
                border={`2px solid ${whiteMode}`}
                position="absolute"
                bottom="0"
                left="22px"
              />
            )}

            <Stack gap={0} textAlign="left">
              <Text
                fontSize="sm"
                color={textPrimaryMode}
                fontWeight="600"
                isTruncated // This will add ellipsis
                maxW="260px"
              >
                {name}
              </Text>
              <Text
                fontSize="xs"
                color={textSecondary}
                fontWeight="500"
                isTruncated // This will add ellipsis
                maxW="220px"
              >
                {email}
              </Text>
              {isMobile && (
                <Flex align="baseline" m="0.25rem 0 0">
                  <StatusBadge isSmall status={status} options="user" />
                  <Text
                    fontSize="xs"
                    color={textSecondary}
                    fontWeight="500"
                    ml={2}
                  >
                    {patientID}
                  </Text>
                </Flex>
              )}
            </Stack>
          </HStack>
        );
      },
    },

    {
      Header: () => (
        <Flex h="100%" w="100%">
          <Flex align="center" cursor="pointer">
            <Text>{t("employee.columnRole")}</Text>
          </Flex>
        </Flex>
      ),
      accessor: "role",
      disableSortBy: true,
      Cell: ({ row }) => {
        const { role } = row.original;

        return (
          <Flex align="center" w="100%">
            <Text
              fontSize="0.8rem"
              color={textSecondary}
              fontWeight="500"
              whiteSpace="nowrap"
              isTruncated
              maxWidth="160px"
            >
              {t(`role.${role}`)}
            </Text>
          </Flex>
        );
      },
    },

    {
      Header: () => (
        <Flex w="100%" h="100%">
          <Flex align="center" cursor="pointer" justify="flex-end" w="100%">
            <Text>{t("patient.columnStatus")}</Text>
          </Flex>
        </Flex>
      ),
      accessor: "status",
      disableSortBy: true,
      preventRowClick: true,
      Cell: ({ row }) => {
        const { status, _id, email } = row.original;

        const isOwner = tenantRegistrationEmail === email;
        const isLoggedInUser = loggedInUserEmail === email;

        return (
          <HStack gap={0} justify="flex-end">
            <StatusButtonNewLite
              p="0 3.5rem"
              size="md"
              currentStatus={status}
              options="user"
            />
            <MoreButtonLite
              isSmall
              id={_id}
              viewHandler={() => {
                setUserId(_id); // Set the user ID for viewing
                openEditSidePanelModal(); // Open side panel modal for viewing/editing
              }}
              viewLabel={t("user.editUser")}
              deleteHandler={true}
              deleteButtonDisabled={isOwner || isLoggedInUser} // Disable delete button if the user is the owner
              setShowDeleteConfirmation={() => {
                setUserId(_id); // Set the user ID for deletion
                setShowDeleteConfirmation(true); // Open confirmation modal
              }}
            />
          </HStack>
        );
      },
    },
  ];
};
